import React, {useState} from 'react';

import {DisplayTeamNameAndDescription} from './DisplayTeamNameAndDescription';
import {EditTeamNameAndDescription} from './EditTeamNameAndDescription';

import type {TeamSerializedType} from 'sweet-types';

interface Props {
  team: TeamSerializedType;
}

export const TeamPageHeader = ({team}: Props): JSX.Element | null => {
  const [isEditMode, setEditMode] = useState(false);

  return (
    <div className="mb-3">
      {!isEditMode ? (
        <DisplayTeamNameAndDescription
          team={team}
          onClick={() => setEditMode(true)}
          showNotMemberMessage={false}
        />
      ) : (
        <EditTeamNameAndDescription
          teamId={team.id}
          name={team.name}
          description={team.description}
          teammateCanAssign={team.teammates_can_assign_task}
          handleClose={() => setEditMode(false)}
        />
      )}
    </div>
  );
};
